export const PUBLIC_OFFERS_TYPE = 'public-offers';
export const DERBYSOFT_TYPE = 'derbysoft';
export const RENTALSUNITED_TYPE = 'rentalsunited';
export const RATEDOCK_TYPE = 'ratedock';
